/** @format */

import React from "react";
import { useNavigate } from "react-router-dom";

//material ui
import { useTheme } from "@mui/styles";
import { Button } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const useStyles = (theme) => ({
	icon: {
		p: "5px",
		height: "14px",
		width: "14px",
		borderRadius: "58px",
		bgcolor: theme.palette.white.main,
		color: theme.palette.blue.main,
		ml: "3px",
	},
	button: {
		fontFamily: theme.typography.inter.medium,
		borderRadius: "100px",
		color: theme.palette.white.main,
		bgcolor: theme.palette.blue.main,
		fontSize: { xs: "16px", md: "18px" },
		lineHeight: { xs: "28.8px", md: "32.4px" },
		minHeight: "52px",
		minWidth: "185px",
		textTransform: "none",
		"&:hover": {
			color: theme.palette.white.main,
			bgcolor: theme.palette.blue.main,
		},
		backgroundImage: "linear-gradient(105deg, #001f55, #062a6a 100%)",
		mt: "25px",
	},
});

const KnowMoreButton = ({ path, innerRef }) => {
	const theme = useTheme();
	const classes = useStyles(theme);

	const navigate = useNavigate();

	const handleRedirect = () => {
		if (path) {
			navigate(path);
			window.scrollTo(0, 0);
		} else if (innerRef) {
			innerRef.current?.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<Button
			endIcon={<ArrowForwardIosIcon sx={classes.icon} />}
			variant="contained"
			sx={classes.button}
			onClick={handleRedirect}>
			Saber más
		</Button>
	);
};

export default KnowMoreButton;
